"use client";

import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import ServicesSection from "./ServicesSection";
import AchievementsSection from "./AchievementsSection";
import TestimonialsSection from "./TestimonialsSection";
import PartnersSection from "./PartnersSection";
import FoundersSection from "./FoundersSection";
import ContactSection from "./ContactSection";

export default function HomePageInteractive() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <AchievementsSection />
      <TestimonialsSection />
      <PartnersSection />
      <FoundersSection />
      <ContactSection />
    </>
  );
}